import * as _ from 'lodash';
import config from '@nerdwallet/app-config';

const DEFAULT_PROPS = {
  globalNavProps: {
    breadcrumbs: {},
  },
  searchServicesBaseUri:
    config.API.BASE_URLS.SEARCH || 'https://www.nerdwallet.com/api/search',
  searchEnabled: true,
};

// lodash merge gets confused trying to combine arrays and objects, so this
// includes special logic to identify arrays vs. objects (since according to javascript,
// arrays are objects ¯\_(ツ)_/¯)
function getType(input) {
  return Array.isArray(input) ? 'array' : typeof input;
}

/**
 * @param {Array} pageTaxonomy - array of objects defining page taxonomy
 * @param {String} valueName - name of the value in page taxonomy object desired
 */
export function extractPageTaxonomyValue(pageTaxonomy, valueName) {
  const taxonomyArray = Array.isArray(pageTaxonomy) ? pageTaxonomy : [];
  const matched = taxonomyArray.find(
    ({ nwVarName }) => nwVarName === valueName
  );
  return matched?.value;
}

export function getGlobalNavProps(props = {} as any) {
  return {
    // Hide header / footer UI when user is browsing in the mobile app
    disableHeader: props.isNWMobileApp,
    ...props.globalNavProps,
    ..._.pick(props, [
      'theme',
      'clientID',
      'pageVertical',
      'pageTaxonomy',
      'originatingUrl',
      'disclaimers',
      'copyright',
      'searchServicesBaseUri',
      'searchEnabled',
      'bypassBlockTargetId',
      'segmentTrackingAttributes',
    ]),
    isLoggedIn: props.isLoggedIn,
    firstName: props.identity?.firstName,
    baseUrl: props.assetsBaseUrl,
    globalNavItems: props.globalNavItems,
    preferenceCenterMenuItem:
      props.featureFlags?.preferenceCenterMenuItem ?? {},
    savedArticlesMenuItem: props.featureFlags?.savedArticlesMenuItem ?? {},
    nerdWalletPlusActive: props.featureFlags?.nerdWalletPlusActive,
    abTests: props.abTests?.abTests ?? [],
    experiments: props.experiments?.experimentDecisions ?? [],
    segmentTrackingAttributes: props.segmentTrackingAttributes,
    responseVersion: 1,
  };
}

// Check that the type of the input props match the default props (with some special logic to differentiate objects and arrays)
// and log an error if they differ
export function validateProps(inputProps = {}, logger) {
  if (!logger) {
    return;
  }

  const props = Object.keys(DEFAULT_PROPS);

  props.forEach((prop) => {
    // if inputProps does not set the value for this prop, there can be no type conflict
    if (!inputProps[prop]) {
      return;
    }

    // if the type of the input props does not match the default prop, or if one is an object while the other is an array, log an error
    if (getType(inputProps[prop]) !== getType(DEFAULT_PROPS[prop])) {
      logger.error(
        `An invalid type was provided for ${prop} - expected ${getType(
          DEFAULT_PROPS[prop]
        )} but found ${getType(inputProps[prop])}`
      );
    }
  });
}
